import { usePageData } from '@streaming-advisor/contentful';
import { environment } from 'environments/environment';
import { DefaultPageProps } from 'types/PageProps';

export const usePageContentData = <T extends DefaultPageProps>(
  routeId: string,
  isPreview?: boolean
): T => usePageData<T>(environment.contentfulEnv, routeId, isPreview);
